import { render } from "./Number.svg?vue&type=template&id=6cdbc310"
const script = {}
script.render = render

export default script